export default __webpack_public_path__ + "static/media/MP5_8.a84f452a.png";